import { Button, Menu, MenuItem, styled } from '@mui/material';

export const StyledGradeBookFormatWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',
}));

export const StyledGradeBookFormatButton = styled(Button, {
	shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>(({ theme, isOpen }) => ({
	color: isOpen ? theme.palette.primary.main : 'inherit',
	minWidth: '48px',
	height: '48px',
	borderRadius: '8px',
	padding: 0,
	backgroundColor: isOpen ? '#fff' : 'transparent',
	'&:hover': {
		backgroundColor: '#fff',
	},
	'& .MuiButton-startIcon': {
		margin: 0,
	},
	'& svg': {
		width: '24px',
		height: '24px',
	},
}));

export const StyledGradeBookFormatMenu = styled(Menu)(() => ({
	'& .MuiPaper-root': {
		background: '#fff',
		borderRadius: '8px',
		padding: '8px',
		overflow: 'hidden',
	},
}));

export const StyledGradeBookFormatMenuItem = styled(MenuItem)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	padding: '10px 8px',
	minWidth: '160px',
	'& svg': {
		width: '24px',
		height: '24px',
	},
	'&.Mui-selected': {
		backgroundColor: '#F1F8FE !important',
		color: theme.palette.primary.main,
	},
	'&.Mui-selected:hover': {
		backgroundColor: theme.palette.primary.main,
	},
}));
